import React, { useEffect, useState } from 'react';
import { uploadQuestionnaire, uploadCorporateClassQuestionnaire } from '@lib/api/index';
import { Trans } from '@lib/i18n/index';
import UploadItem from 'components/Documents/UploadItem';
import QuestionsWrapper from './QuestionsWrapper';
import DocumentItemsWrapper from 'components/Documents/DocumentItemsWrapper';

const QuestionsUploadWrapper = ({
  title,
  subtitleTransCode,
  classId,
  handleStatusBar,
  setRefresh,
  isCorporate = false,
}) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleFileUpload = async (selectedFileChange) => {
    if (!selectedFileChange) return;
    setIsLoading(true);
    const formData = new FormData();
    formData.append('file', selectedFile);
    try {
      let response;
      if (!isCorporate) {
        response = await uploadQuestionnaire(classId, formData);
      } else {
        response = await uploadCorporateClassQuestionnaire(classId, formData);
      }
      if (response.status) {
        setIsLoading(false);
        handleStatusBar('success', <Trans code='A0654' />, true);
        setRefresh(true);
      } else {
        setIsLoading(false);
        handleStatusBar('error', response.message, true);
      }
    } catch (error) {
      console.error('Error uploading file', error);
    }
    setSelectedFile(null);
  };

  useEffect(() => {
    if (selectedFile) {
      handleFileUpload(selectedFile);
    }
  }, [selectedFile]);

  return (
    <DocumentItemsWrapper
      title={title}
      subtitleTransCode={subtitleTransCode}
      sectionTitleTransCode={'A0828'}
      isUpload={true}
      permittedFiles={'xlsx'}>
      <UploadItem setSelectedFile={setSelectedFile} isLoading={isLoading} />
    </DocumentItemsWrapper>
  );
};

export default QuestionsUploadWrapper;
